import workbench from './workbench';


export default {
    path: 'workbench',
    component: () => import('@layout/empty'),
    children: [
        workbench,
    ]
}